import { Skeleton } from "@ternary/ui"

/**
 * A form while it loads: `label` as status text for a screen reader, and on screen a label bar over
 * an input bar for each of `fields` fields, the shape of the form that replaces it.
 */
export function FormLoading({ label, fields }: { label: string; fields: number }) {
  return (
    <>
      <p className="tny-visually-hidden" role="status">
        {label}
      </p>
      <div aria-hidden="true" className="admin-form-loading">
        {Array.from({ length: fields }, (_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: identical placeholders that never reorder.
          <div className="admin-form-loading-field" key={index}>
            <Skeleton width="8rem" />
            <Skeleton height="2.75rem" />
          </div>
        ))}
      </div>
    </>
  )
}
